import { useState } from 'react';
import PropTypes from 'prop-types';

import MobileHeader from '../MobileHeader';
import MobileMenu from '../MobileMenu';

import styles from './MobileLayout.module.scss';

/**
 * 모바일 레이아웃 컴포넌트
 * - 모바일 화면 (767px 이하)에서 사용
 * - 모바일 헤더와 메뉴를 포함
 */
function MobileLayout({ title, children, showNotification, onNotificationClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function handleMenuOpen() {
    setIsMenuOpen(true);
  }

  function handleMenuClose() {
    setIsMenuOpen(false);
  }

  return (
    <div className={styles.layout}>
      {/* 모바일 헤더 */}
      <MobileHeader
        title={title}
        onMenuClick={handleMenuOpen}
        onNotificationClick={onNotificationClick}
        showNotification={showNotification}
      />

      {/* 메인 콘텐츠 */}
      <main className={styles.main}>{children}</main>

      {/* 모바일 메뉴 (오버레이) */}
      <MobileMenu isOpen={isMenuOpen} onClose={handleMenuClose} />
    </div>
  );
}

MobileLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  showNotification: PropTypes.bool,
  onNotificationClick: PropTypes.func,
};

MobileLayout.defaultProps = {
  children: null,
  showNotification: false,
  onNotificationClick: () => {},
};

export default MobileLayout;
